/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Field, Form } from 'formik';
import FormikInputField from 'components/Fields/FormikInputField';
import LoadingButton from 'components/common/LoadingButton';

const EditDeliveredQuantityForm = (props) => {
  const { handleSubmit, drawerToggle, isSubmitting } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <h5 className="fw-bold">Is this the final delivered quantity ?</h5>
      <Row>
        <Col sm={4}>
          <Field
            label="Delivered Quantity"
            name="deliveredQuantity"
            type="number"
            component={FormikInputField}
            required
          />
        </Col>
      </Row>
      <div className="f-12 fw-bold">
        Please note : All the calculations will be based on this quantity.
      </div>

      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={drawerToggle}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          // disabled={!isValid || !dirty || isSubmitting}
          color="primary"
          size="sm"
          type="submit"
        >
          Save
        </LoadingButton>
      </div>
    </Form>
  );
};

export default EditDeliveredQuantityForm;
